export const DRAWER_WIDTH = 256;

export const TYPEKEV_SITE_PREFERS_COLOR_SCHEME = 'typekev-site-prefers-color-scheme';

export const TYPEKEV_SITE_PREV_WELCOMED = 'typekev-site-prev-welcomed';

export const COLOR_SCHEME_CODE_MAP = { LIGHT: 'LIGHT', DARK: 'DARK' };

export default {
  DRAWER_WIDTH,
  TYPEKEV_SITE_PREFERS_COLOR_SCHEME,
  COLOR_SCHEME_CODE_MAP,
};
